import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { toPointer } from '../../core/issues.js';

/**
 * Fields that are not allowed on a scoreDelta. `reactionText` was removed from
 * the supported shape — the runtime does not read it, so its presence is a
 * content error rather than harmless extra data.
 */
const FORBIDDEN = ['reactionText'] as const;

export const scoreDeltaForbiddenFields: Rule<Gameshow> = {
  code: 'gameshow.score-delta.forbidden-field',
  check(input): ValidationIssue[] {
    const issues: ValidationIssue[] = [];

    input.nodes.forEach((node, nodeIdx) => {
      for (const [outcomeId, effect] of Object.entries(node.outcomeEffects ?? {})) {
        (effect.scoreDeltas ?? []).forEach((delta, deltaIdx) => {
          const raw = delta as Record<string, unknown>;
          for (const field of FORBIDDEN) {
            if (raw[field] === undefined) {
              continue;
            }
            const path: (string | number)[] = [
              'nodes',
              nodeIdx,
              'outcomeEffects',
              outcomeId,
              'scoreDeltas',
              deltaIdx,
              field,
            ];
            issues.push({
              code: 'gameshow.score-delta.forbidden-field',
              severity: 'error',
              message: `Field '${field}' is not allowed on a scoreDelta.`,
              path,
              pointer: toPointer(path),
              locator: { nodeId: node.id },
              currentValue: raw[field],
              constraint: { kind: 'custom', detail: `scoreDelta field '${field}' not allowed` },
              fix: { kind: 'remove', rationale: `${field} is not a supported scoreDelta field` },
            });
          }
        });
      }
    });

    return issues;
  },
};
